import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Col, Card } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { addToCart } from "../../utils/functionMenu";
import { useCart } from "../../utils/CartContext";
import { toast } from 'react-toastify';
import { getAuth } from "firebase/auth";

export default function AnimatedCard({ item, index, handleImageError }) {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true });
  const location = useLocation();
  const navigate = useNavigate();
  const { cart, refreshCartCount, setCartCount } = useCart();
  const [added, setAdded] = useState(false);

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    }
  }, [inView, controls]);

  if (!item) return null;

  // تحقق من اكتمال بيانات المنتج
  const isValidProduct = item.id && item.title && item.imgUrl && item.newPrice;
  if (!isValidProduct) {
    console.warn("بيانات المنتج ناقصة أو غير صحيحة:", item);
  }

  // دالة عند الضغط على اطلب الآن
  const handleOrderNow = () => {
    const auth = getAuth();
    if (!auth.currentUser) {
      toast.error("يرجى تسجيل الدخول أولاً لإضافة عناصر إلى السلة!");
      navigate("/auth");
      return;
    }
    if (!isValidProduct) {
      toast.error("هناك خطأ في بيانات المنتج، لا يمكن إضافته للسلة.");
      return;
    }
    addToCart({
      id: item.id,
      name: item.title,
      price: item.newPrice,
      img: item.imgUrl,
    }, cart);
    // تحديث عداد السلة فورًا
    const newCartCount = Array.isArray(cart) ? cart.reduce((sum, item) => sum + (item.quantity || 1), 0) + 1 : 1;
    setCartCount(newCartCount);
    setAdded(true);
    setTimeout(() => setAdded(false), 1200); // يرجع الزر للوضع الطبيعي بعد 1.2 ثانية
  };
  return (
    <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 30 }}
        animate={controls}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        <Card className="menu-card shadow-sm border-0 h-100">
          <div className="image-container">
            <Card.Img
              variant="top"
              src={item.imgUrl}
              className="img-item"
              alt={item.title}
              onError={handleImageError}
            />
          </div>
          <Card.Body className="text-end d-flex flex-column justify-content-between">
            <div>
              <Card.Title className="item-title">{item.title}</Card.Title>
              <Card.Text className="item-description">
                {item.description}
              </Card.Text>
            </div>
            <div>
              <div className="d-flex align-items-center justify-content-start gap-2 mb-3">
                <span className="old-price">{item.oldPrice} د.أ</span>
                <span className="item-price">{item.newPrice} د.أ</span>
              </div >

              {/* ✅ عرض الزر فقط إذا ما كانت الصفحة الرئيسية وبيانات المنتج مكتملة */}
              {isValidProduct && location.pathname === '/menu' && (
                <button
                className={`btn-order-now w-100${added ? ' disabled' : ''}`}                  onClick={handleOrderNow}
                  disabled={added}
                  style={{ marginTop: '0.5rem' }}
                >
                  {added ? 'تمت الإضافة!' : 'اطلب الآن'}
                </button>
              )}
            </div>
          </Card.Body>
        </Card>
      </motion.div>
    </Col>
  );
}
